import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import ChatView from '../components/chat/ChatView';

function ChatTest() {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Typography sx={{ mb: 3 }} variant="h4">
        Chat Feature Test
      </Typography>

      <Box sx={{ border: '1px solid #ccc', height: 'calc(100vh - 200px)' }}>
        <ChatView
          companyId="550e8400-e29b-41d4-a716-446655440010"
          userId="test-user-123"
          userLanguage="en"
        />
      </Box>
    </Container>
  );
}

export default ChatTest;
